export const neutralColorScale = {
    0: "#000000",
    4: "#091010",
    5: "#101010",
    6: "#0E1515",
    10: "#1C1C1C",
    12: "#1A2120",
    15: "#292929",
    17: "#232B2B",
    20: "#313131",
    22: "#303735",
    24: "#333B39",
    25: "#3D3D3D",
    30: "#484848",
    35: "#4B5453",
    40: "#5E5E5E",
    50: "#7A7A7A",
    60: "#909090",
    70: "#AAAAAA",
    80: "#C7C7C7",
    87: "#D4DCDB",
    90: "#E3E3E3",
    92: "#E2EAE9",
    94: "#E7EFEE",
    95: "#F0F0F0",
    96: "#EDF5F4",
    98: "#F5F5F5",
    99: "#FAFAFA",
    100: "#FFFFFF",
};
